var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{attrs:{"data-test":"enabled-via"}},[_c('CheckCircleIcon',{staticClass:"mr-2 text-success",attrs:{"size":"lg"}}),_vm._v("\n  "+_vm._s(_vm.enabledViaText)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }